module.exports = __webpack_public_path__ + "static/img/kh-7.c2e5189.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/kh-7.png
// module id = CPzb
// module chunks = 5